<template>
  <div>
    <div>
      <div>Current selection has {{ selectedAssets.length }} assets</div>
      <ul class="list-unstyled">
        <li v-for="(assets, status) in groupedAssets">
          {{ humanize(status) }}: {{ assets.length }}
        </li>
      </ul>
    </div>

    <div class="d-flex justify-content-between align-items-end">
      <div>
        <b-form-group :label="`Change selected assets status to ${humanize(selectedOption)}`">
          <b-form-radio-group
              v-model="selectedOption"
              :options="options"
              buttons/>
        </b-form-group>

        <b-form-group label="Reason" v-if="requiresReason">
          <b-form-select
              v-model="reason"
              :options="availableReasons"/>
        </b-form-group>

        <div v-if="selectedOption === 'buyout'">
          <b-form-group label="BUY OUT EXPIRES">
            <date-range-picker
                v-model="buyOutDateRange"
                :ranges="false"
                :single-date-picker="true"
                :auto-apply="true"
                :locale-data="pickerLocale"/>
          </b-form-group>

          <div class="text-primary cursor-pointer"
               v-if="buyOutDateRange.startDate"
               @click="buyOutDateRange = makePickerEmptyDate()">
            Clear
          </div>
        </div>


      </div>

      <div>
        <b-button variant="secondary" @click="$emit('cancel')">Cancel</b-button>
        <b-button variant="primary" :disabled="!validForm"
                  @click="handleBulkStatus">
          <pulse-loader v-if="bulkActionRunning"
                        :loading="bulkActionRunning"
                        size="10px"
                        color="#00C0F4"
                        class="mx-2"/>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import groupBy from "lodash/groupBy";
import GeneralMixins from "../../../../mixins/GeneralMixins";
import PulseLoader from 'vue-spinner/src/PulseLoader';
import DateRangePicker from 'vue2-daterange-picker'

export default {
  props: ['selectedAssets', 'idKey'],

  model: {
    prop: 'selectedAssets',
    event: 'change'
  },

  mixins: [GeneralMixins],

  components: {PulseLoader, DateRangePicker},

  data() {
    return {
      bulkActionRunning: false,
      selectedOption: null,
      reason: null,
      idKeyName: this.idKey || 'id',
      buyOutDateRange: this.makePickerEmptyDate(),
      options: [
        {text: 'Approved', value: 'approved'},
        {text: 'Rejected', value: 'rejected'},
        {text: 'Pending', value: 'pending'},
        {text: 'Changes Requested', value: 'changes_requested'},
        // {text: 'Buy Out', value: 'buyout'},
        {text: 'Deactivated', value: 'deactivated'},
      ]
    }
  },

  watch: {
    selectedOption() {
      this.reason = null
    }
  },

  methods: {
    makePickerEmptyDate() {
      return {
        startDate: null,
        endDate: null
      }
    },


    handleBulkStatus: function () {
      const status = this.selectedOption
      const reason = this.reason

      let attributes = {
        asset_ids: this.selectedAssets.map(img => img[this.idKeyName]),
        asset: {
          status: status,
        }
      };

      if (this.requiresReason) {
        attributes.asset.notes = reason
      }

      if (status === 'buyout') {
        attributes.asset.buyout_expires_at = this.buyOutParamDate
      }

      this.bulkActionRunning = true;

      this.$http.post("/curators/bulk/asset_statuses", attributes).then(result => {
        this.showToast("Selected assets were updated successfully", "Success")
        this.selectedOption = null
        this.selectedAssets.forEach(asset => {
          asset.status = status
          asset.notes = reason
        })
        this.$emit('change', this.selectedAssets)
      }, rejectionResult => {
        this.showErrorToast(null, rejectionResult.body.errors)
      }).then(result => {
        this.bulkActionRunning = false
      });
    },
  },

  computed: {
    pickerLocale() {
      return {
        format: 'mm/dd/yyyy'
      }
    },

    buyOutParamDate() {
      let start = this.buyOutDateRange.startDate
      if (start instanceof Date) {
        start = start.toISOString().split('T')[0]
      }
      return start || ""
    },

    validForm() {
      if (this.selectedOption) {
        return this.validateReason
      }

      return false
    },

    validateReason() {
      if (this.requiresReason) {
        return this.reason && this.reason.length > 0
      }
      return true
    },

    requiresReason() {
      return ['changes_requested', 'rejected', 'deactivated'].includes(this.selectedOption)
    },

    groupedAssets() {
      return groupBy(this.selectedAssets, asset => asset.status)
    },

    availableReasons() {
      return window.reasonStore.availableReasons(this.selectedOption)
    }
  }
}
</script>